<app-leveltwo [pageName]="'Possessory Interests'">
<div class="General">
  <h3>{{'PossessoryInterest.PageTitle'|translate}}</h3>

  <p>{{'PossessoryInterest.Whenaperson'|translate}}</p>

  <h4>{{'PossessoryInterest.Valuing'|translate}}</h4>

  <p>{{'PossessoryInterest.Abaseyear'|translate}}</p>

  <ol>
    <li>{{'PossessoryInterest.Onlytherights'|translate}}</li>
    <li>{{'PossessoryInterest.TheAssessormust'|translate}}</li>
  </ol>

  <p>{{'PossessoryInterest.Asaresult'|translate}}</p>

  <h4>{{'PossessoryInterest.ValuationMethod'|translate}}</h4>
  <p>{{'PossessoryInterest.Whenanew'|translate}}</p>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'PossessoryInterest.IncomeApproach'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
        <p>{{'PossessoryInterest.Thisisthe'|translate}}</p>
        <p>{{'PossessoryInterest.Usingthe'|translate}}</p>

      </accordion-group>
      <accordion-group #drop2>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'PossessoryInterest.ComparativeSales'|translate}} <i class="mt-1 float-end" [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
        <p>{{'PossessoryInterest.Inthisapproach'|translate}}</p>

      </accordion-group>

      <accordion-group #drop3>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'PossessoryInterest.Costapproach'|translate}} <i class="mt-1 float-end" [ngClass]="!drop3.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
        <p>{{'PossessoryInterest.Inthecost'|translate}}</p>
        <p>{{'PossessoryInterest.Considering'|translate}}</p>

      </accordion-group>

    </accordion>
  </div>

</div>

</app-leveltwo>
